import { useState, useEffect, useMemo } from 'react';
import api from '../services/api';
import { useLang } from '../contexts/LanguageContext';

// /!\ NE PAS utiliser `|| 'localhost:5000'` après le replace : si REACT_APP_API_URL='/api',
// alors '/api'.replace('/api','') = '' qui est falsy → fallback inattendu sur localhost.
const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const serverUrl = apiUrl.replace(/\/api\/?$/, '');

// Toutes les images sont servies par le backend (uploads/ et photos_bijoux/)
const resolveImg = (path) => {
  if (!path) return '';
  return path.startsWith('/') ? `${serverUrl}${path}` : path;
};

// Helper : retourne la version EN si lang === 'en' ET le champ EN est rempli,
// sinon retourne la version FR (fallback).
const i18nField = (base, en, lang) => {
  if (lang === 'en' && en && en.trim()) return en;
  return base || '';
};

const normalize = (lang) => (p, idx) => ({
  id: p._id,
  num: idx + 1, // numéro affiché (1-indexed)
  name: i18nField(p.name, p.nameEn, lang),
  type: p.type || '',
  story: i18nField(p.story, p.storyEn, lang),
  status: p.status,
  stone: i18nField(p.stone, p.stoneEn, lang),
  origin: i18nField(p.origin, p.originEn, lang),
  size: p.size || '',
  available: p.available ?? 0,
  img: resolveImg(p.images?.[0]?.path),
  images: (p.images || []).map(i => resolveImg(i.path)).filter(Boolean),
  relatedProducts: (p.relatedProducts || []).map(r => ({
    id: r._id,
    name: i18nField(r.name, r.nameEn, lang),
    type: r.type || '',
    stone: i18nField(r.stone, r.stoneEn, lang),
    status: r.status,
    img: resolveImg(r.images?.[0]?.path),
  })),
});

export function usePieces() {
  const { lang } = useLang();
  const [rawPieces, setRawPieces] = useState([]); // données brutes du backend (sans i18n)
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api.get('/products')
      .then(res => {
        if (cancelled) return;
        setRawPieces(res.data);
      })
      .catch(err => console.error('Erreur chargement bijoux :', err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  // On normalise à chaque changement de langue (pas besoin de refetch l'API)
  const pieces = useMemo(() => rawPieces.map(normalize(lang)), [rawPieces, lang]);

  return { pieces, loading };
}
